/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Team_Filter_PlannedInputs */



/**
* | output |
* | --- |
* | "Planned conversations ({count})" |
*
* @param {Team_Filter_PlannedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_filter_planned = /** @type {((inputs: Team_Filter_PlannedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Filter_PlannedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Geplande gesprekken (${i?.count})`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Conversations prévues (${i?.count})`)
	return /** @type {LocalizedString} */ (`Planned conversations (${i?.count})`)
});